import React, { useEffect, useState } from 'react';
import { Gift } from 'lucide-react';
import { verifyInviteCode } from '../../services/api/inviteService';

const BANNER =
  'mb-5 rounded-lg border border-primary/20 bg-primary/5 px-4 py-3 text-left';
const HEAD = 'flex items-center gap-2 text-sm font-bold text-slate-900';
const LINE = 'm-0 mt-1.5 text-xs leading-5 text-slate-600';

interface InviterBannerProps {
  /** 招待URLから受け取ったコード。無ければ何も出さない。 */
  code: string | null;
}

/**
 * 招待リンクから来た人に「誰の招待か」を見せるバナー。
 *
 * 仕様 2-3 が求めるのは次の3点だけ。
 *  - 誰の招待で来たか
 *  - URLを入れるだけで広告バナーが作れること
 *  - 7日間の無料トライアルがあること
 *
 * クレジットがもらえるのは招待した人だけなので、被招待者が報酬を得ると
 * 読める表現は書かない。専用の招待LPも作らない（signup 上部に出すだけ）。
 */
const InviterBanner: React.FC<InviterBannerProps> = ({ code }) => {
  const [inviterName, setInviterName] = useState<string | null>(null);

  useEffect(() => {
    if (!code) {
      setInviterName(null);
      return;
    }

    let cancelled = false;

    verifyInviteCode(code).then((result) => {
      if (!cancelled && result.valid && result.inviter_name) {
        setInviterName(result.inviter_name);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [code]);

  // 失効・不正なコードや名前が取れない場合は黙って出さない。
  // 招待リンクが切れているだけの人の登録を妨げないため、エラーは見せない。
  if (!inviterName) {
    return null;
  }

  return (
    <div className={BANNER} role="status">
      <p className={HEAD}>
        <Gift className="h-4 w-4 text-primary" aria-hidden />
        {inviterName}さんの招待です
      </p>
      <p className={LINE}>商品URLを貼るだけで、広告バナーが作れます。</p>
      <p className={LINE}>7日間の無料トライアルからお試しいただけます。</p>
    </div>
  );
};

export default InviterBanner;
